import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const operatorsEndpoints = config.endpoints.operators

const getOperators = () =>
  axios({
    method: 'get',
    url: operatorsEndpoints.user,
    headers: getHeaders(true),
  })

const getOperatorsOnline = () =>
  axios({
    method: 'get',
    url: operatorsEndpoints.totalOnline,
    headers: getHeaders(true),
  })

const updateOperator = (user) =>
  axios({
    method: 'put',
    url: operatorsEndpoints.user,
    headers: getHeaders(true),
    data: { user },
  })

const updateTokenFirebase = (token) =>
  axios({
    method: 'put',
    url: operatorsEndpoints.putTokenFirebase,
    headers: getHeaders(true),
    data: { token },
  })

const getCenters = () =>
  axios({
    method: 'get',
    url: operatorsEndpoints.centers,
    headers: getHeaders(true),
  })

/**
 * Change operator loggedIn status
 * @param {boolean} isAvailable
 */
const available = (isAvailable) => {
  if (typeof isAvailable !== 'boolean') throw new Error('isAvailable is not a boolean.')

  return axios({
    method: 'post',
    url: operatorsEndpoints.available,
    headers: getHeaders(true),
    data: { available: isAvailable }
  })
}

export default {
  getOperators,
  updateOperator,
  getOperatorsOnline,
  updateTokenFirebase,
  getCenters,
  available
}
